import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const DownloadStemsIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="11" y="9" width="10" height="2" fill={fillColor || 'black'} />
      <rect x="3" y="5" width="18" height="2" fill={fillColor || 'black'} />
      <rect x="15" y="13" width="6" height="2" fill={fillColor || 'black'} />
      <rect x="12" y="17" width="9" height="2" fill={fillColor || 'black'} />
      <path d="M8 9V18M8 18L3 13M8 18L13 13" stroke={fillColor || 'black'} strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
};

export { DownloadStemsIcon };
